import ScanButton from "features/ScanButton";
import React from "react";
import { useAppSelector } from "shared/redux/hooks";
import { userSelect } from "shared/redux/selectors/user";
import Header from "widgets/Header";
import BecomeMember from "widgets/Home/BecomeMember";
import Gift from "widgets/Home/Gift";
import Gifts from "widgets/Home/Gifts";
import HeroSlider from "widgets/Home/HeroSlider";
import Search from "widgets/Home/Search";
import UserInfo from "widgets/Home/UserInfo";

const Home: React.FC = () => {
  const { user_info } = useAppSelector(userSelect);

  return (
    <main>
      <Header />
      <HeroSlider />
      <Gift />
      <Search />
      {user_info && <UserInfo />}
      {!user_info && <BecomeMember />}
      <Gifts />

      <ScanButton />
    </main>
  );
};

export default Home;
